import { useContext } from 'react';
import Tippy from '@tippyjs/react';
import { ChatbotContext } from './chatbot-context';
import { CitationContent } from './citation-content';
import { CitationIcon } from './citation-icon';
import { ChatbotCitationDocument } from './types';

interface ChatbotMessageSourceProps {
  document: ChatbotCitationDocument;
  onClick: () => void;
}

/**
 * Singe source item
 */
export function ChatbotMessageSource({ document, onClick }: ChatbotMessageSourceProps) {
  const aiContext = useContext(ChatbotContext);

  return (
    <Tippy
      content={<CitationContent doc={document} currentPortalId={aiContext.portalSettings?.id} />}
      placement="top-start"
      arrow={false}
      delay={[200, 200]}
      duration={200}
      interactive={true}
      animation="scale"
      appendTo={window.document.body}
    >
      <div
        onClick={onClick}
        className="border border-[#EFF2F2] inline-block p-1 rounded bg-white mb-2 mr-2 cursor-pointer group hover:bg-[#F5F5F5]"
      >
        <div className="flex items-center">
          <CitationIcon docType={document.type} />
          <div className="ml-[6px] max-w-[200px] whitespace-nowrap overflow-hidden overflow-ellipsis">
            {document.title}
          </div>
        </div>
      </div>
    </Tippy>
  );
}
